const styles = {
  grid: {
    margin: '1rem 0 0 0 !important',
  },
  chartContent: {
    backgroundColor: '#fff',
    padding: '1.75em !important',
    borderRadius: '.25em !important',
    boxShadow:
      '0 .0625em 0 0 rgba(0,0,0,0.03), 0 .125em .375em 0 rgba(0,0,0,0.06) !important',
    margin: '0 !important',
  },
  charts: {
    width: '100%',
    height: '18.75rem',
    marginTop: '1rem',
  },
  label: {
    fontSize: '.8em !important',
    marginBottom: '3em !important',
  },
  ref: {
    width: '100%',
    padding: '0 !important',
  },
};

export default styles;
